import { ExternalIntegrationEnum } from 'api/clients/ExternalIntegrationsClient'
import { BrandPlanTactic } from 'types'

export const SUPPORTED_PROVIDERS = [
  ExternalIntegrationEnum.Instagram,
  ExternalIntegrationEnum.Facebook,
  ExternalIntegrationEnum.LinkedIn,
  ExternalIntegrationEnum.X,
  ExternalIntegrationEnum.TikTok,
  ExternalIntegrationEnum.Google,
  ExternalIntegrationEnum.WordPress,
  ExternalIntegrationEnum.Mailchimp,
  ExternalIntegrationEnum.YouTube,
]

export const TACTIC_TO_PROVIDER: ReadonlyArray<{ tactic: BrandPlanTactic; provider: ExternalIntegrationEnum }> = [
  { tactic: BrandPlanTactic.Instagram, provider: ExternalIntegrationEnum.Instagram },
  { tactic: BrandPlanTactic.InstagramReel, provider: ExternalIntegrationEnum.Instagram },
  { tactic: BrandPlanTactic.Facebook, provider: ExternalIntegrationEnum.Facebook },
  { tactic: BrandPlanTactic.LinkedIn, provider: ExternalIntegrationEnum.LinkedIn },
  { tactic: BrandPlanTactic.Twitter, provider: ExternalIntegrationEnum.X },
  { tactic: BrandPlanTactic.TikTok, provider: ExternalIntegrationEnum.TikTok },
  { tactic: BrandPlanTactic.YouTube, provider: ExternalIntegrationEnum.YouTube },
  { tactic: BrandPlanTactic.Email, provider: ExternalIntegrationEnum.Mailchimp },
  { tactic: BrandPlanTactic.SEO, provider: ExternalIntegrationEnum.WordPress },
] as const

export const ORDERED_PROVIDERS = [
  ExternalIntegrationEnum.Facebook,
  ExternalIntegrationEnum.Instagram,
  ExternalIntegrationEnum.LinkedIn,
  ExternalIntegrationEnum.X,
  ExternalIntegrationEnum.YouTube,
  ExternalIntegrationEnum.TikTok,
  ExternalIntegrationEnum.Google,
  ExternalIntegrationEnum.WordPress,
  ExternalIntegrationEnum.Mailchimp,
]
